import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import requestingReducer from './requesting/RequestingReducer';
import errorReducer from './error/ErrorReducer';
import toastsReducer from './toasts/ToastsReducer';
import masterReducer from './master/MasterReducer';
import { i18nReducer } from 'react-redux-i18n';
import CreateQuestionnaireReducer from './createQuestionnaire/CreateQuestionnaireReducer';

export default function rootReducer(history) {
  const reducerMap = {
    error: errorReducer,
    requesting: requestingReducer,
    router: connectRouter(history),
    master: masterReducer,
    i18n: i18nReducer,
    questionnaire: CreateQuestionnaireReducer,
  };

  return combineReducers(reducerMap);
}
